import * as React from "react";
import { useSelector } from "react-redux";
import { COLORS, ROLES } from "../../../core/consts/redesign/commonRedesign";
import { Basket, Docs, Img } from "../../../core/consts/redesign/icons";
import { isImageFile } from "../../../core/helpers/isImageFile";
import { DocsStatusEnum, LeadDocInnerType } from "../../../core/types/leadsApiTypes";
import { LeadDocExampleType } from "../../../core/types/partnerApiTypes";
import { rootState } from "../../../core/types/rootState";
import IconButtonMain from "../../../UIcomponentsRedesign/IconButtonMain/IconButtonMain";
import { useStyles } from "./DocPreviewStyles";

type IProps = {
  file: LeadDocInnerType | LeadDocExampleType;
  handleDocClick?: (fileId: number, fileName: string) => void;
  handleDelete: (e: React.MouseEvent<HTMLElement> | React.TouchEvent<HTMLElement>, fileId: number, fileName?: string) => void;
  allDocPacksStatus?: DocsStatusEnum;
  isDocSent?: boolean;
  currentLeadArchive?: boolean;
  isPartnerExample?: boolean;
};

const DocPreview: React.FC<IProps> = ({
  file,
  handleDocClick,
  handleDelete,
  allDocPacksStatus,
  isDocSent,
  currentLeadArchive,
  isPartnerExample
}) => {
  const classes = useStyles();
  const initialUser = useSelector((state: rootState) => state.currentUser);
  const isManager = initialUser.role === ROLES.MANAGER;
  const isPartner = initialUser.role === ROLES.PARTNER;
  const fileSize = file.size > 0 ? file.size : 0.01
  const allUploadedAndSent = allDocPacksStatus === DocsStatusEnum.DocumentsSend;

  if (!file) return null;
  return (
    <>
      <div id={file?.id?.toString()}
        title="Скачать"
        className={classes.container}
        style={{ justifyContent: currentLeadArchive || allUploadedAndSent || isPartner || isManager ? 'flex-start' : 'space-between' }}
        onClick={() => handleDocClick && handleDocClick(file.id, file.name)}>
        {isImageFile(file.name) ?
          <Img color={COLORS.gray2} /> :
          <Docs color={COLORS.gray2} />
        }
        <div className={classes.desc}>
          <span className={classes.docTitle}>{file.name}</span>
          <span className={classes.docSize}>{fileSize} мб</span>
        </div>
        {(!currentLeadArchive && (!allUploadedAndSent && !isDocSent) && !isPartner && !isManager)
          || isPartnerExample
          ?
          <IconButtonMain
            className={classes.removeButton}
            color='noBgGray'
            title="Удалить"
            aria-label="close"
            icon={<Basket />}
            handleClick={(e: React.MouseEvent<HTMLElement> | React.TouchEvent<HTMLElement>) =>
              handleDelete(e, file.id, file.name)
            }
          /> : null}
      </div>
    </>
  );
};

export default DocPreview;